import { DownOutlined, RightOutlined } from '@ant-design/icons';
import { Dropdown, Grid } from 'antd';
import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useDecafTheme } from '../theme';

export interface BreadcrumbItem {
  title: ReactNode;
  href?: string;
  children?: { title: ReactNode; href?: string }[];
}

export interface BreadcrumbProps {
  items: BreadcrumbItem[];
  itemRender?: (item: BreadcrumbItem) => ReactNode;
  separator?: ReactNode;
}

export function Breadcrumb(props: BreadcrumbProps) {
  const { items, itemRender, separator } = props;
  const { theme } = useDecafTheme();
  const breakpoints = Grid.useBreakpoint();

  const firstAndLAst = items.slice(0, 1).concat(items.slice(-1));
  const _items = breakpoints.lg ? items : firstAndLAst;

  return (
    <ul className={`decaf-breadcrumb ${theme}`}>
      {renderBreadcrumbs(_items, separator || <RightOutlined />, itemRender)}
    </ul>
  );
}

function renderBreadcrumbs(
  items: BreadcrumbItem[],
  separator: ReactNode,
  itemRender?: (item: BreadcrumbItem) => ReactNode
) {
  const result: ReactNode[] = [];

  items.forEach((item, i) => {
    const isLast = i === items.length - 1;

    if (item.href && !isLast) {
      result.push(
        <li key={i}>
          {itemRender ? (
            itemRender(item)
          ) : (
            <Link className="decaf-breadcrumb-link" to={item.href}>
              {item.title}
            </Link>
          )}
        </li>
      );
    } else if (item.children) {
      const dmenu = item.children.map((child, j) => ({
        key: j,
        label: (
          <Link className="decaf-breadcrumb-link" to={child.href!}>
            {child.title}
          </Link>
        ),
      }));

      result.push(
        <li key={i}>
          <Dropdown menu={{ items: dmenu }}>
            <div style={{ display: 'flex', cursor: 'pointer', gap: 3 }}>
              <span>{item.title}</span>
              <DownOutlined style={{ fontSize: 12 }} />
            </div>
          </Dropdown>
        </li>
      );
    } else {
      result.push(<li key={i}>{item.title}</li>);
    }
    if (i < items.length - 1) {
      result.push(
        <li key={`sep-${i}`} className="separator">
          {separator}
        </li>
      );
    }
  });

  return result;
}
